import React from 'react'

const Results = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/results',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <path
      fill={primaryColor}
      d='M.605 8.392h4.697c.289 0 .522-.308.522-.689 0-.38-.233-.688-.522-.688H.605c-.288 0-.522.308-.522.688 0 .381.234.689.522.689zM.575 3.799h9.35c.272 0 .492-.308.492-.689 0-.38-.22-.689-.492-.689H.575c-.271 0-.492.309-.492.689 0 .381.221.689.492.689zM9.925 16.201H.575c-.271 0-.492.308-.492.689 0 .381.221.689.492.689h9.35c.272 0 .492-.308.492-.689 0-.381-.22-.689-.492-.689zM.605 12.985h4.697c.289 0 .522-.307.522-.688 0-.381-.233-.689-.522-.689H.605c-.288 0-.522.308-.522.689 0 .381.234.688.522.688z'
    />
    <path
      fill={secondaryColor}
      d='M10.522 9.215c0-1.771 1.405-3.212 3.131-3.212 1.727 0 3.132 1.441 3.132 3.212 0 1.771-1.405 3.212-3.132 3.212-1.726 0-3.131-1.441-3.131-3.212zm9.211 5.327l-2.573-2.639c.549-.751.878-1.68.878-2.688 0-2.48-1.968-4.497-4.385-4.497S9.269 6.735 9.269 9.215c0 2.479 1.967 4.496 4.384 4.496.983 0 1.889-.337 2.622-.9l2.573 2.639a.613.613 0 0 0 .885 0 .653.653 0 0 0 0-.908z'
    />
  </svg>
)

export default Results
